<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-text>
                    <v-tabs
                        v-model="tab"
                        color="purple"
                        flat
                    >
                        <v-tab
                            key="myAccount"
                            :to="{ name: 'receivementsLyndusPay', params: { } }"
                        >
                            <v-icon left>mdi-account-cash</v-icon>
                            Lyndus Pay
                        </v-tab>
                        <v-tab
                            key="movements"
                            :to="{ name: 'receivementsGeneral', params: { } }"
                        >
                            <v-icon left>mdi-format-list-bulleted</v-icon>
                            Geral
                        </v-tab>
                        <!--                        <v-tab-->
                        <!--                            key="extract"-->
                        <!--                            :to="{ name: 'financialExtract', params: { } }"-->
                        <!--                        >-->
                        <!--                            <v-icon left>mdi-format-list-checks</v-icon>-->
                        <!--                            Extrato-->
                        <!--                        </v-tab>-->
                        <!--                        <v-tab-->
                        <!--                            key="myPlan"-->
                        <!--                            :to="{ name: 'financialMyPlan', params: { } }"-->
                        <!--                        >-->
                        <!--                            <v-icon left>mdi-cash-register</v-icon>-->
                        <!--                            Meu Plano-->
                        <!--                        </v-tab>-->

                    </v-tabs>
                </v-card-text>
                <v-tabs-items v-model="tab">
                    <router-view></router-view>
                </v-tabs-items>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
// import store from "@/store";
// import NumberInput from '@/components/NumberInput'
//
//
// import {banks} from "@/common/banks.list";
//
// import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";
//
// import {
//     BANK_ACCOUNT_CREATE,
//     BANK_ACCOUNT_DEFAULT,
//     BANK_ACCOUNT_DELETE,
//     BANK_ACCOUNTS_GET, FINANCE_CREATE, FINANCE_GET, FINANCE_SEARCH
// } from "@/store/actions/financial.type";
// import {
//     FINANCIAL_RESET_STATE,
//    
// } from "@/store/mutations/financial.type";


export default {
    name: "financial",
    directives: {mask},
    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        // await store.commit(FINANCIAL_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        // await store.commit(FINANCIAL_RESET_STATE);
        // await store.dispatch(BANK_ACCOUNTS_GET);
        // await store.dispatch(FINANCE_GET);

        return next();
    },
    data: () => ({
        // textRules: [
        //     (v) => !!v || "Este campo é obrigatório",
        //     //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        // ],
        // selected: [],
        // options: {},
        // headers: [
        //     {text: "Data", align: "left", value: "requestDate"},
        //     {text: "Saldo Liberado", value: "valueReleased"},
        //     {text: "Valor Antecipado", value: "valueAnticipation"},
        //     {text: "Valor Total", value: "totalValue"},
        //     // {text: "Usuário", value: "username"},
        //     {text: "Visualizar", value: "actions", sortable: false}
        // ],
        tab: null,
        bankAccountIndex: null,
        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0
        },

        // formIsValid: false,
        // optionsMoney: {
        //     locale: "pt-BR",
        //     prefix: "R$:",
        //     length: 9,
        //     precision: 2
        // },
        // active: false,
        // btnBalanceCheck: true,
        //
        // dialogRescueBalance: false,
        // dialogBalance: false,
        // dialogBankAccount: false,
        //
        //
        // dialogBankRemove: false,
        // socialEdit: false,
        // updateLogo: null,


        // social: {
        //     socialID: 0,
        //     url: "",
        // },
        //
        // balance: {
        //     socialID: 0,
        //     url: "",
        // },
        // subtitle: {
        //     socialID: 0,
        //     url: "",
        // },
        //
        // pixRules: [
        //     v => !!v && !!this.bankAccount.bank && this.bankAccount.agency && this.bankAccount.account || "Este campo é obrigatório"
        //     //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        // ],


    }),

    methods: {
        // rescueRules(v) {
        //     let n = parseFloat(v.replace(".", "").replace(",", "."))
        //     if (isNaN(n)) return "Informe um valor válido ";
        //
        //     if (n < 1) return "O Valor Mínimo é de R$ 1,00";
        //
        //     if (this.finance.balanceTotal < n) return "O Valor informado é maior que o Saldo Total";
        //
        //     return true
        // },
        // bankRulesValid(v) {
        //     if (!this.bankAccount.chavePIX) {
        //         return !!v || "Este campo é obrigatório"
        //     }
        //     return true
        // },
        // pixRulesValid(v) {
        //     if (!this.bankAccount.bank && !this.bankAccount.agency && !this.bankAccount.account) {
        //         return !!v || "Este campo é obrigatório"
        //     }
        //     return true
        // },
        //
        //
        // querySelections(v) {
        //     this.localBanks = banks.filter(e => {
        //         return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        //     })
        // },


        // removeBankDialog(id, index) {
        //     this.dialogBankRemove = true;
        //     this.bankAccount.id = id
        //     this.bankAccountIndex = index
        // },
        // dialogRescueBalanceDialog() {
        //
        //     this.dialogRescueBalance = true;
        //     for (let i = 0; i < this.bankAccounts.length; i++) {
        //         if (this.bankAccounts[i].default) {
        //             this.balanceRequest.bankID = this.bankAccounts[i].id
        //             return
        //         }
        //     }
        //
        // },
        // loadExtract() {
        //     this.buscar()
        // },
        // async buscar() {
        //     const {sortBy, sortDesc, itemsPerPage, page} = this.options
        //     console.log(sortBy, sortDesc, itemsPerPage, page)
        //     store.commit(SET_FINANCE_PAGINATION, {
        //         page: page,
        //         itemsPerPage: itemsPerPage,
        //         orderBy: sortBy,
        //         sortDesc: sortDesc[0]
        //     })
        //     await store.dispatch(FINANCE_SEARCH);
        // },
        // async rescueBalance() {
        //
        //     this.dialogRescueBalance = false;
        //
        //     await this.$store
        //         .dispatch(FINANCE_CREATE, this.balanceRequest)
        //         .then(response => {
        //             this.$store.commit(CHANGE_PROGRESS, false);
        //
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Salvo com sucesso";
        //
        //             this.$refs.formBalanceRescue.reset()
        //             this.$router.push({
        //                 name: "financialView",
        //                 params: {id: response.data.id}
        //             });
        //         })
        //         .catch(({response}) => {
        //             this.$store.commit(CHANGE_PROGRESS, false);
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao Salvar";
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text =
        //                     "Erro ao salvar: " + response.data.message;
        //             }
        //         });
        //
        //
        // },
        // async submitBankAccount() {
        //     if (this.$refs.formBankAccount.validate()) {
        //         this.$store.commit(CHANGE_PROGRESS, true);
        //
        //         await this.$store
        //             .dispatch(BANK_ACCOUNT_CREATE, this.bankAccount)
        //             .then(async () => {
        //                 this.$store.commit(CHANGE_PROGRESS, false);
        //
        //                 this.snackbar.snackbar = true;
        //                 this.snackbar.color = "success";
        //                 this.snackbar.text = "Salvo com sucesso";
        //
        //                 await store.dispatch(BANK_ACCOUNTS_GET);
        //
        //
        //                 this.$refs.formBankAccount.resetValidation();
        //                 this.$refs.formBankAccount.reset();
        //
        //
        //                 this.dialogBankAccount = false;
        //             })
        //             .catch(({response}) => {
        //                 this.$store.commit(CHANGE_PROGRESS, false);
        //                 this.dialogBankAccount = false;
        //                 this.snackbar.snackbar = true;
        //                 this.snackbar.color = "error";
        //                 this.snackbar.text = "Erro ao salvar dados bancários";
        //                 if (typeof response.data.message !== "undefined") {
        //                     this.snackbar.text =
        //                         "Erro ao salvar dados bancários: " + response.data.message;
        //                 }
        //             });
        //     } else {
        //         this.snackbar.snackbar = true;
        //         this.snackbar.color = "error";
        //         this.snackbar.text = "Preencha o formulário corretamente";
        //     }
        // },
        // async removeBank() {
        //     await this.$store
        //         .dispatch(BANK_ACCOUNT_DELETE, this.bankAccount.id)
        //         .then(async () => {
        //             this.$store.commit(CHANGE_PROGRESS, false);
        //
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Removido com sucesso";
        //
        //             await store.commit(REMOVE_BANK_ACCOUNT, this.bankAccountIndex);
        //         })
        //         .catch(({response}) => {
        //             this.$store.commit(CHANGE_PROGRESS, false);
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao remover dados bancários";
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text =
        //                     "Erro ao remover dados bancários: " + response.data.message;
        //             }
        //         });
        //     this.dialogBankRemove = false;
        //     this.bankAccountIndex = null;
        // },

        // async setDefaultBank(id, index) {
        //     await this.$store
        //         .dispatch(BANK_ACCOUNT_DEFAULT, id)
        //         .then(async () => {
        //             this.$store.commit(CHANGE_PROGRESS, false);
        //
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Alterado com sucesso";
        //
        //             await store.commit(SET_BANK_ACCOUNTS_DEFAULT, index);
        //         })
        //         .catch(({response}) => {
        //             this.$store.commit(CHANGE_PROGRESS, false);
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao alterar";
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text =
        //                     "Erro ao alterar: " + response.data.message;
        //             }
        //         });
        // },

        //Dialog Balance - Botão Liberar Saldo

        // closeBalance() {
        //     this.$refs.formBalance.resetValidation();
        //     this.socialEdit = false;
        //     this.dialogBalance = false;
        //     this.social.socialID = null;
        //     this.social.url = "";
        // },


        //Dialog Bank Account - Botão Adicionar (Conta)
        // closeBankAccount() {
        //     this.$refs.formBankAccount.resetValidation();
        //     this.socialEdit = false;
        //     this.dialogBankAccount = false;
        //     this.social.socialID = null;
        //     this.social.url = "";
        // },


    },
    watch: {
        // search(val) {
        //     val && val !== this.select && this.querySelections(val)
        // },
        // balanceRequestValue(val) {
        //     // this.finance.balanceReleased = 500
        //     // this.finance.balanceToReleased = 500
        //     // this.finance.balanceTotal = 1000
        //
        //     this.balanceRequest.valueReleased = 0
        //     this.balanceRequest.valueToReleased = 0
        //     this.balanceRequest.valueTotal = 0
        //     this.balanceRequest.valueRate = 0
        //     this.balanceRequest.value = this.balanceRequestValue
        //
        //     if (this.finance.balanceTotal < val || val < 1) {
        //         this.btnBalanceCheck = true
        //         return
        //     } else if (this.finance.balanceReleased >= val) {
        //         this.balanceRequest.valueReleased = this.finance.balanceReleased - (this.finance.balanceReleased - val)
        //         this.balanceRequest.valueTotal = (this.balanceRequest.valueReleased + this.balanceRequest.valueToReleased) - this.balanceRequest.valueRate
        //     } else {
        //         this.balanceRequest.valueReleased = this.finance.balanceReleased
        //
        //         let rest = val - this.balanceRequest.valueReleased
        //
        //         if (this.finance.balanceToReleased >= rest) {
        //
        //             this.balanceRequest.valueToReleased = this.finance.balanceToReleased - (this.finance.balanceToReleased - rest)
        //             this.balanceRequest.valueRate = this.balanceRequest.valueToReleased * (this.finance.rateAnticipation / 100)
        //             this.balanceRequest.valueTotal = (this.balanceRequest.valueReleased + this.balanceRequest.valueToReleased) - this.balanceRequest.valueRate
        //         }
        //     }
        //     this.btnBalanceCheck = false
        // },

        // options: {
        //     handler() {
        //         this.buscar()
        //     },
        //     deep: true,
        // },
    },
    computed: {
        // ...
        //     mapGetters(["snackbar", "bankAccount", "bankAccounts", "finance", "finances", "financePagination"]),
        ...
            mapGetters(["snackbar"]),

    }
    ,
}
;
</script>